const LEGACY_GLOBAL_KEYS = [
  'GLOBAL_COLOR', 'GLOBAL_BACKGROUND', 'titleName', 'titleIcon',
  'description', 'padding', 'allMode'
]

function isObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

// 与门户设计器 parseStyleObject 的旧 extra 迁移规则保持一致。
export function normalizeGlobalStyle(raw) {
  let style = raw
  if (typeof raw === 'string') {
    try { style = JSON.parse(raw) } catch (e) { return {} }
  }
  if (!isObject(style)) return {}
  const result = { ...style }
  if (isObject(style.extra)) {
    Object.keys(style.extra).forEach(key => {
      if (result[key] === undefined) result[key] = style.extra[key]
    })
    LEGACY_GLOBAL_KEYS.forEach(key => {
      if (style.extra[key] !== undefined) result[key] = style.extra[key]
    })
  }
  delete result.extra
  return result
}

// 更换模板/站点时先清除上份配置的变量，避免残留上一个站点的颜色。
export function applyGlobalStyle(state, style) {
  const rootStyle = document.documentElement.style
  Object.keys(state.globalStyle).forEach(key => rootStyle.removeProperty(`--theme-${key}`))
  state.globalStyle = style
  Object.keys(style).forEach(key => {
    const value = style[key]
    if (typeof value === 'string' || typeof value === 'number') {
      rootStyle.setProperty(`--theme-${key}`, String(value))
    }
  })
}
